import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InsuranceProfessionDTO  {
    _originalTypeClassName = "zERP.BO.InsuranceProfessionDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InsuranceProfessionDTO.translate = translateService;
}
this.Id = null;
this.Fullname = null;
this.InsuranceProfessionDTOKey = null;
this._key = this.InsuranceProfessionDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Fullname:any;
private _InsuranceProfessionDTOKey:any;
get InsuranceProfessionDTOKey(): any {
    return this._InsuranceProfessionDTOKey;
  }
set InsuranceProfessionDTOKey(value: any) {
    this._InsuranceProfessionDTOKey = value;
    this._key = value;
  }

static Assign(ip: any): any{let ipDTO = new Domain.InsuranceProfessionDTO();
ipDTO.Id = ip?.Id;
ipDTO.Fullname = Domain.InsuranceProfession.GetFullName(ip);
return ipDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InsuranceProfessionDTOKey == null || $this.InsuranceProfessionDTOKey == 0;
            }


}